import { Grid } from "@mui/material";
import FormGridContainer from "atoms/Forms/FormGridContainer";
import { useInputChoicesContext } from "misc/customHooks";
import { ContactInfoFieldsType } from "pages/SharedRecords.types";
import { AutocompleteInput, AutocompleteInputProps, required, TextInput, TextInputProps } from "react-admin";
import { useWatch } from "react-hook-form";

type AddressInputsPropsType = Omit<TextInputProps, "source"> & {
  sourcePrefix?: string;
  inCreate?: boolean;
  omitFields?: ContactInfoFieldsType[];
  requiredFields?: ContactInfoFieldsType[];
};

export default function AddressInputs({
  sourcePrefix = "",
  inCreate = false,
  omitFields = [],
  requiredFields = [],
  ...props
}: AddressInputsPropsType) {
  const labelPrefix = "resources.users.fields.contact_info";
  const countrycode = useWatch({ name: `${sourcePrefix}countrycode` }) as string | undefined;
  const countryChoices = useInputChoicesContext("countries");

  return (
    <FormGridContainer>
      {!omitFields.includes("co") && (
        <Grid item xs={12}>
          <TextInput {...props} label={`${labelPrefix}.co`} source={`${sourcePrefix}co`} fullWidth />
        </Grid>
      )}

      {!omitFields.includes("address_line_1") && (
        <Grid item xs={12} md={6}>
          <TextInput
            {...props}
            label={`${labelPrefix}.address_line_1`}
            source={`${sourcePrefix}address_line_1`}
            validate={requiredFields.includes("address_line_1") ? required() : undefined}
            fullWidth
          />
        </Grid>
      )}
      {!omitFields.includes("address_line_2") && (
        <Grid item xs={12} md={6}>
          <TextInput
            {...props}
            label={`${labelPrefix}.address_line_2`}
            source={`${sourcePrefix}address_line_2`}
            fullWidth
          />
        </Grid>
      )}

      {!omitFields.includes("postcode") && (
        <Grid item xs={12} md={3}>
          <TextInput
            {...props}
            label={`${labelPrefix}.postcode`}
            source={`${sourcePrefix}postcode`}
            validate={requiredFields.includes("postcode") ? required() : undefined}
            fullWidth
          />
        </Grid>
      )}
      {!omitFields.includes("city") && (
        <Grid item xs={12} md={9}>
          <TextInput
            {...props}
            label={`${labelPrefix}.city`}
            source={`${sourcePrefix}city`}
            validate={requiredFields.includes("city") ? required() : undefined}
            fullWidth
          />
        </Grid>
      )}

      {!inCreate && !omitFields.includes("state") && (countrycode === "DE" || !countrycode) && (
        <Grid item xs={12}>
          <TextInput {...props} label={`${labelPrefix}.state`} source={`${sourcePrefix}state`} readOnly fullWidth />
        </Grid>
      )}

      {!omitFields.includes("countrycode") && (
        <Grid item xs={12}>
          <AutocompleteInput
            label={`${labelPrefix}.country`}
            source={`${sourcePrefix}countrycode`}
            choices={countryChoices}
            {...(props as AutocompleteInputProps)}
          />
        </Grid>
      )}
    </FormGridContainer>
  );
}
